<template>
  <button aria-controls="navbar-default" aria-expanded="false" type="button">
    <SidebarIconClose class="w-7 h-7" />
  </button>
</template>

<style scoped>
button {
  @apply lg:hidden inline-flex items-center text-sm text-gray-500 rounded-lg dark:text-gray-400;
}
</style>
